import * as React from "react";
import styled from "styled-components";
import RhumbixLogo from "../../../assets/rhumbix-icon-with-name.png";
import { colorMiscGray90, colorFunctionalWhite } from "@rhumbix/rmbx_design_system_design_tokens";
import "@rhumbix/rmbx_design_system_design_tokens/dist/design-tokens.css"; // For Quantico font-family
const defaultTitle = "ERROR";
/**
 * @prop {string} id Component id.
 * @prop {string} [description] Error description.
 * @prop {boolean} [enableButtons] Show "Back" & "Go To Rhumbix Dashboard" buttons.
 * @prop {string} [title] Error title.
 * @prop {string|SVG} [titleImage] Image to show on the top.
 * @prop {Object} [pageHistory] Page navigation utils.
 */
const ErrorPage = ({ id, description, enableButtons, title, titleImage, pageHistory, }) => {
    return (React.createElement(StyledErrorPage, { id: id },
        React.createElement(StyledRmbxLogo, { src: RhumbixLogo, alt: "RHUMBIX" }),
        React.createElement(StyledContentContainer, null,
            titleImage && (React.createElement("img", { src: titleImage, alt: "TITLE IMAGE", height: "60", width: "105", style: { color: colorFunctionalWhite } })),
            React.createElement(StyledTitle, { titleImage: !!titleImage }, title || defaultTitle),
            description && React.createElement(StyledDescription, { titleImage: !!titleImage }, description),
            enableButtons && (React.createElement(React.Fragment, null,
                React.createElement(StyledBtn, { onClick: () => pageHistory.goBack() }, "Back"),
                React.createElement(StyledBtn, { onClick: () => pageHistory.push("/rhumbix/") }, "Go To Rhumbix Dashboard"))))));
};
export default ErrorPage;
const StyledErrorPage = styled.div `
    height: 100vh;
    width: 100vw;
    background-color: ${colorMiscGray90};
    position: relative;
`;
const StyledRmbxLogo = styled.img `
    margin-left: 36px;
    margin-top: 20px;
    width: 200px;
    height: 42px;
    color: ${colorFunctionalWhite};
`;
const StyledContentContainer = styled.div `
    color: ${colorFunctionalWhite};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const StyledTitle = styled.h1 `
    font-size: ${props => (props.titleImage ? "32px" : "60px")};
    ${props => !props.titleImage && "font-family: Quantico, Roboto;"}
    margin-bottom: 20px;
`;
const StyledDescription = styled.h3 `
    color: ${colorFunctionalWhite}; // Override default h3 color defined in main.less
    font-size: ${props => (props.titleImage ? "18px" : "26px")};
    margin-top: 0px;
    margin-bottom: 10px;
    font-weight: 300;
`;
const StyledBtn = styled.button `
    height: 40px;
    width: 210px;
    background-color: Transparent;
    color: ${colorFunctionalWhite};
    border: 1px solid ${colorFunctionalWhite};
    margin-top: 20px;
    &:hover {
        background-color: ${colorFunctionalWhite};
        color: ${colorMiscGray90};
        cursor: pointer;
    }
`;
